import tw from "twin.macro";

export const CardSection = tw.div`min-h-[184.8rem] bg-[#0E1222] -mt-[0.8rem]`;
